import { useTheme } from '@emotion/react';
import StopColors from './Charts/CircleChart/StopColors';

export type LegendCircleProps = {
  id: string;
  colors?: string[];
};

const LegendCircle = ({ id, colors }: LegendCircleProps) => {
  const theme: any = useTheme();
  return (
    <svg width="12" height="12">
      <defs>
        <linearGradient id={`gradient-${id}`} x1="8.95%" y1="106.5%" x2="91.05%" y2="-6.5%">
          <StopColors colors={colors ?? [theme.palette.colorPalette[1], theme.palette.colorPalette[2]]} />
        </linearGradient>
      </defs>
      <circle cx="6" cy="6" r="6" fill={`url(#gradient-${id})`} />
    </svg>
  );
};

export default LegendCircle;
